/**
 * Chatbot Service API Configuration
 * Used with TanStack Query for chatbot-related operations
 */

export const chatbotConfig = {
  registerChatbotService: {
    key: "registerChatbotService",
    url: "/api/v1/chat-bot/registration?operation=registerChatbotService",
    method: "POST",
    options: {
      invalidateKeys: [], // Add keys to invalidate if needed
    },
  },
  chatbotCreateBookingAddon: {
    key: "chatbotCreateBookingAddon",
    url: "/api/v1/chat-bot/booking-verification?operation=createBookingAddon",
    method: "POST",
    options: {
      invalidateKeys: [], // Add keys to invalidate if needed
    },
  },

  generateChatbotJwtToken: {
    key: "generateChatbotJwtToken",
    url: (data) =>
      `/api/v1/chat-bot/booking-verification?operation=generateJwtToken&propertyId=${data.propertyId}`,
    method: "GET",
    options: {
      retry: 2,
      invalidateKeys: [], // No cache invalidation needed for token generation
    },
  },

  refreshChatbotJwtToken: {
    key: "refreshChatbotJwtToken",
    url: "/api/v1/chat-bot/booking-verification?operation=refreshJwtToken",
    method: "GET",
    options: {
      retry: 1,
      invalidateKeys: [], // No cache invalidation needed for token refresh
      // Custom headers will be added via apiClient when calling
    },
  },
};
